import { useLayoutEffect, useRef } from 'react'

// Recalcula também ao redimensionar o chat, pois a quebra automática muda.
export default function ChatMessageInput({ value, ...props }) {
  const input = useRef(null)
  const resize = () => {
    const element = input.current
    if (!element) return
    const style = getComputedStyle(element)
    const line = parseFloat(style.lineHeight)
    const padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)
    const border = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth)
    const maximum = line * 8 + padding + border
    element.style.height = 'auto'
    element.style.overflowY = 'hidden'
    const contentHeight = element.scrollHeight + border
    element.style.height = `${Math.min(maximum, Math.max(line + padding + border, contentHeight))}px`
    element.style.overflowY = contentHeight > maximum ? 'auto' : 'hidden'
  }
  useLayoutEffect(resize, [value])
  useLayoutEffect(() => {
    let width = input.current.getBoundingClientRect().width
    const observer = new ResizeObserver(([entry]) => {
      const nextWidth = entry.target.getBoundingClientRect().width
      if (nextWidth !== width) { width = nextWidth; resize() }
    })
    observer.observe(input.current)
    return () => observer.disconnect()
  }, [])
  return <textarea {...props} ref={input} value={value} rows={1} />
}
